module.exports = __webpack_public_path__ + "img/BIGC.0f51c4d.png";